import { compose, find, prop, propEq } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconButton from '../../../components/actions/IconButton'

const ViewSelect = ({ value, form }) => {
  const { t } = useTranslation('common')
  const navigate = useNavigation()

  const options = [
    {
      label: t('views.listReplies'),
      value: 'list',
      iconLeft: 'BsListTask',
      onClick: () => navigate(`/forms/${form.id}/form-replies`)
    },
    {
      label: t('views.graphics'),
      value: 'analytics',
      iconLeft: 'BsListTask',
      onClick: () => navigate(`/forms/${form.id}/resume`)
    }
  ]

  const label = compose(prop('label'), find(propEq('value', value || 'list')))(options)

  return (
    <DropdownLink
      actionContent={<IconButton iconLeft="BsListTask" label={label} transparent noWrap />}
      options={options}
    />
  )
}

export default ViewSelect
